export function getDate() {
  const dateTimeLocal = new Date();
  const hour = dateTimeLocal.getHours().toString().padStart(2, '0');
  const minutes = dateTimeLocal.getMinutes().toString().padStart(2, '0');
  const day = dateTimeLocal.getDate().toString().padStart(2, '0');
  const month = (dateTimeLocal.getMonth() + 1).toString().padStart(2, '0');
  const year = dateTimeLocal.getFullYear().toString();
  const dayName = dateTimeLocal.toLocaleString('es-ES', {
    weekday: 'long',
  });

  const dateString = `${day}/${month}/${year}`;

  return {
    hour,
    minutes,
    day,
    month,
    year,
    dayName,
    dateString,
  };
}
